import flags from "@assets/images/flags.png";
import { IContactNumber, IPaxTypeQuantity } from "@common/models";
import Button from "@components/general/form/Button";
import DateRangeInput from "@components/general/form/DateRangeInput";
import DropDown, { DisplayMode } from "@components/general/form/DropDown";
import PhoneSection from "@components/general/form/PhoneSection";
import TextArea from "@components/general/form/TextArea";
import TextInput from "@components/general/form/TextInput";
import { IconMode } from "@components/general/Icon";
import PaxType from "@components/general/PaxType";
import { IAppState } from "@misc/State";
import Translate from "@service/Translate";
import { nameof } from "@utilize/Util";
import { FC, useState } from "react";
import { useSelector } from "react-redux";

interface IEnquiryRequest {
    gender?: string;
    firstName?: string;
    lastName?: String;
    startRange?: number;
    endRange?: number;
    email?: string;
    comment?: string;
    nationality?: string;
    mobile?: IContactNumber;
    paxTypeQuantity?: IPaxTypeQuantity;
}

const Enquiry: FC = () => {
    const { tr } = Translate;
    const { countriesData, genders } = useSelector((state: IAppState) => ({
        countriesData: state.countriesData,
        genders: state.genders
    }));
    const [enquiryRequest, setEnquiryRequest] = useState<IEnquiryRequest>({
        mobile: {
            internationalCode: '98'
        }
    });

    const onEnquiryRequestChange = (name: string, value: any) => {
        enquiryRequest[name as keyof IEnquiryRequest] = value;
        setEnquiryRequest({ ...enquiryRequest });
    }

    const onMobileChange = (name: string, value: any) => {
        if (enquiryRequest.mobile)
            enquiryRequest.mobile[name as keyof IContactNumber] = value;
        setEnquiryRequest({ ...enquiryRequest });
    }

    return (
        <div className="enquiry">
            <div className="row flex">
                <div className="col-1-2 col-sm-1-1">
                    <div className="row flex spa-2">
                        <div className="col-2-5">
                            <DropDown
                                label={tr("title")}
                                name={nameof<IEnquiryRequest>("gender")}
                                value={genders.find(g => g.code === enquiryRequest.gender)}
                                selectOptionsMode
                                dataSource={genders}
                                itemDisplayFormat={"adultPrefix"}
                                valueKey="code"
                                onChange={onEnquiryRequestChange}
                            />
                        </div>
                        <div className="col-3-5 first-name">
                            <TextInput
                                name={nameof<IEnquiryRequest>("firstName")}
                                value={enquiryRequest.firstName}
                                label={tr("first_name")}
                                onBlur={onEnquiryRequestChange}
                            />
                        </div>
                    </div>
                    <TextInput
                        name={nameof<IEnquiryRequest>("lastName")}
                        value={enquiryRequest.lastName}
                        label={tr("last_name")}
                        onBlur={onEnquiryRequestChange}
                    />
                    <DateRangeInput
                        startRange={enquiryRequest.startRange ?? 0}
                        endRange={enquiryRequest.endRange ?? 0}
                        gridCount={2}
                        options={{
                            arrival: {
                                placeholder: 'Tour End Date',
                                name: nameof<IEnquiryRequest>("endRange"),
                                label: 'Tour End Date'
                            },
                            departure: {
                                placeholder: 'Tour Start Date',
                                name: nameof<IEnquiryRequest>("startRange"),
                                label: 'Tour Start Date'
                            }
                        }}
                        index={0}
                        onChange={onEnquiryRequestChange}
                        name="tourStartDate"
                    />
                    <DropDown
                        label={tr("nationality")}
                        name={nameof<IEnquiryRequest>("nationality")}
                        value={countriesData.find(c => c.code === enquiryRequest.nationality)}
                        dataSource={countriesData}
                        itemDisplayFormat="demonym"
                        valueKey="code"
                        displayMode={DisplayMode.TextAndIcon}
                        iconSetting={{ mode: IconMode.Position, iconField: "flagPosition", path: flags, width: "24px", height: "3876px" }}
                        onChange={onEnquiryRequestChange}
                    />
                    <PaxType
                        name="paxTypeQuantity"
                        paxType={enquiryRequest.paxTypeQuantity || { adt: 1, chd: 0, inf: 0, yad: 0 }}
                        onChange={onEnquiryRequestChange}
                    />
                </div>
                <div className="col-1-2 col-sm-1-1">
                    <PhoneSection
                        type="phone"
                        label={tr("mobile")}
                        dataSource={enquiryRequest}
                        autoComplete="on"
                        dataMember={nameof<IEnquiryRequest>("mobile")}
                        onChange={onMobileChange}
                    />
                    <TextInput
                        label={tr("email")}
                        name={nameof<IEnquiryRequest>("email")}
                        value={enquiryRequest.email}
                        type="email"
                        onBlur={onEnquiryRequestChange}
                    />
                    <TextArea
                        label={tr("Your commnet")}
                        name={nameof<IEnquiryRequest>("comment")}
                        value={enquiryRequest.comment}
                        onBlur={onEnquiryRequestChange}
                        style={{ height: '194px' }}
                    />
                </div>
            </div>
            <div className="row flex justify-end">
                <div className="col-1-4 col-sm-1-1">
                    <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        text={tr('submit')}
                    />
                </div>
            </div>
        </div>
    )
}

export default Enquiry;